import IconButton from '@material-ui/core/IconButton'
import { WithStyles, withStyles, Theme } from '@material-ui/core/styles'
import createStyles from '@material-ui/core/styles/createStyles'
import Tooltip from '@material-ui/core/Tooltip'
import InfoIcon from '@material-ui/icons/InfoOutlined'
import classNames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { BiDownload } from 'react-icons/bi'

import CardHeader from './CardHeader'

const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: '80px',
      display: 'flex',
      flexDirection: 'column',
    },
    title: {
      flex: 1,
      fontSize: 24,
      fontWeight: 'bold',
      color: theme.palette.primary.main || '#0e85ff',
      padding: 20,
    },
    separator: {
      width: '100%',
      minHeight: 1,
      backgroundColor: '#EBEDF3',
    },
    exportIcon: {
      cursor: 'pointer',
    },
    button: {
      marginRight: 10,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.spacing(1),
    },
    iconButton: {
      background: '#ECF5FF',
      borderRadius: '4px',
      height: '36px',
      width: '36px',
      padding: 0,
      color: theme.palette.primary.main,
    },
    container: {
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: '5px 10px',
    },
    hidden: {
      visibility: 'hidden',
    },
    tooltip: {
      fontSize: 13,
    },
  })

interface ICardHeaderProps extends WithStyles<typeof styles> {
  children?: React.ReactNode
  className?: string
  displayTooltip: boolean
  filter?: { icon: any; onClick: (event: React.MouseEvent<HTMLElement>) => void; title: string }
  hideFilterBtn?: boolean
  onClickExport?: (event: any) => void
  showSeparator?: boolean
  toolTipTitle: string
}

function CardMenuContainer(props: ICardHeaderProps) {
  const {
    classes,
    className,
    children,
    showSeparator = true,
    onClickExport,
    filter,
    displayTooltip,
    toolTipTitle,
    hideFilterBtn,
  } = props
  const { t } = useTranslation()
  if (!children && !displayTooltip && !onClickExport) {
    return null
  }

  return (
    <CardHeader className={classNames(classes.root, className)}>
      <div className={classes.container}>
        {children}
        <div className={classes.button}>
          {displayTooltip && (
            <Tooltip title={toolTipTitle} placement="bottom" classes={{ tooltip: classes.tooltip }}>
              <InfoIcon color="primary" data-testid="info-icon" />
            </Tooltip>
          )}
          {filter && !hideFilterBtn && (
            <Tooltip title={filter.title} placement="bottom" classes={{ tooltip: classes.tooltip }}>
              <IconButton className={classes.iconButton} id="filter-button" onClick={filter.onClick}>
                <filter.icon className={classes.exportIcon} />
              </IconButton>
            </Tooltip>
          )}
          {onClickExport && (
            <Tooltip title={t('common.export') as string} placement="bottom" classes={{ tooltip: classes.tooltip }}>
              <IconButton className={classes.iconButton} onClick={onClickExport}>
                <BiDownload className={classes.exportIcon} />
              </IconButton>
            </Tooltip>
          )}
        </div>
      </div>
      {showSeparator && <div className={classes.separator} />}
    </CardHeader>
  )
}

export default withStyles(styles)(CardMenuContainer)
